module.exports = "/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved\n *\n * Licensed under CLOUD LINUX LICENSE AGREEMENT\n * http://cloudlinux.com/docs/LICENSE.TXT\n */\nh2 {\n  font-size: 30px;\n  height: 30px;\n  line-height: 18px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/styles/historical.component.less
// module id = 1203
// module chunks = 1